import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles, withTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import CONSTANTS from '../utils/Constants';
import InvisibleCaptcha from '../components/InvisibleCaptcha';

/*eslint no-mixed-operators: "off"*/

const styles = theme => ({
	center: {
		textAlign: "center"
	},
	positive: {
		backgroundColor: CONSTANTS.COLORS.POSITIVE,
	},
	uncertain: {
		backgroundColor: CONSTANTS.COLORS.UNCERTAIN,
	},
	negative: {
		backgroundColor: CONSTANTS.COLORS.NEGATIVE,
	},
	tip: {
		backgroundColor: CONSTANTS.COLORS.TIP,
	},
	primaryTextColor: {
		borderColor: CONSTANTS.COLORS.WHITE,
		color: CONSTANTS.COLORS.WHITE,
	},
	verticalCenter: {
		margin: 0,
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)"
	},
	screen: {
		display: "inline-block",
		position: "fixed",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		margin: "auto",
		paddingLeft: (theme.spacing.unit * 3.5),
		paddingRight: (theme.spacing.unit * 3.5)
	},
	gap: {
		marginTop: "32vh",
		marginBottom: "2vh",
	},
	heading: {
		paddingBottom: "5vh",
		fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;',
		fontSize: 3 * theme.spacing.unit,
		fontWeight: 900
	}
});

class Thanks extends Component {
	constructor(props, context) {
		super(props, context);
		
		this.state = {
			recaptchaToken: null
		}
	}

	onCloseTap = () => {
		// TODO - handle different cases - embedded as iframe, chrome extension
		const {messageSource} = this.props;

		if(messageSource) {
			messageSource.postMessage({
				type: "APP_CONTROL",
				action: "close"
			}, "*");
		}
		// Still want to go back in case someone posts again without reloading
		setTimeout(() => this.props.history.goBack(), 250);
	}
	
	onRecaptchaChange = token => {
		console.log("New token: ", token.length);
		// console.info(token);
		this.setState({recaptchaToken: token});
	}

	// onContactTap = () => {
	// }

	render() {
		let {classes, match, isMobile, locationContact} = this.props;
		let spacing = 2 * this.props.theme.spacing.unit;
		// fallback on tip if no category
		let category = match.params.category || 'tip';
		let items = [
			(
				<Typography
				className={`${classes.center} ${classes.heading}`}
				color="primary"
				variant="h5"
				classes={{
					colorPrimary: classes.primaryTextColor
				}}>Thank You.</Typography>
			)
		];
		
		const showContact = isMobile && locationContact;

		if(showContact) {
			items = items.concat([
				(
					<Typography
						className={classes.center}
						color="primary"
						variant="h6"
						classes={{
							colorPrimary: classes.primaryTextColor
						}}>Would you like to talk to someone now?</Typography>
				),(
					<Button fullWidth={true}
						variant="outlined"
						className={classes.gap}
						size="large"
						href={`tel:${locationContact}`}
						color="primary"
						aria-label="talk to counselor"
						ga-on="click"
						ga-event-category="WebApp"
						ga-event-action="Button Pressed"
						ga-event-label="Call Someone"
						classes={{
							outlinedPrimary: classes.primaryTextColor,
						}}
					>Yes</Button>
				)
			]);
		}
		
		const label = showContact ? "No thanks"	: "Close";
		const trackLabel = showContact ? "Skip Call Someone" : "Close";
		items.push((
			<Button
				color="primary"
				aria-label="skip talk to counselor"
				ga-on="click"
				ga-event-category="WebApp"
				ga-event-action="Button Pressed"
				ga-event-label={trackLabel}
				classes={{
					flatPrimary: classes.primaryTextColor,
				}}
				onClick={this.onCloseTap}
			>{label}</Button>
		))

		return (
			<div className={`${classes.screen} ${classes[category]}`}>
				<Grid container 
					className={classes.verticalCenter} 
					direction="column" 
					alignItems="center"
					spacing={spacing}>
					{
						items.map((component, idx) => (
							<Grid key={idx} item>{component}</Grid>
						))
					}
				</Grid>
				<InvisibleCaptcha
					action={`thanks_${category}`}
					verifyCallback={this.onRecaptchaChange}
				/>
			</div>
		);
	}
}

Thanks.propTypes = {
	match: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
	messageSource: PropTypes.object.isRequired,
	locationContact: PropTypes.string,
	isMobile: PropTypes.bool
};

export default withStyles(styles)(withTheme()(Thanks));
